import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { TermsContent } from '../legal/TermsContent';
import { PrivacyContent } from '../legal/PrivacyContent';
export function Footer() {
  const [openModal, setOpenModal] = useState<'terms' | 'privacy' | null>(null);
  return <>
      <footer className="bg-[#06080f] py-12 border-t border-white/10" data-id="element-172">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-173">
          <p className="text-sm text-cream-muted text-center md:text-left" data-id="element-174">
            &copy; {new Date().getFullYear()} Protocolo de Sueño Profundo 50+.
            Todos los derechos reservados.
          </p>
          <div className="flex gap-6 text-sm text-cream-muted" data-id="element-175">
            <button onClick={() => setOpenModal('terms')} className="hover:text-gold-400 transition-colors cursor-pointer" data-id="element-176">
              Términos y Condiciones
            </button>
            <button onClick={() => setOpenModal('privacy')} className="hover:text-gold-400 transition-colors cursor-pointer" data-id="element-177">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      <Modal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-178">
        <TermsContent data-id="element-179" />
      </Modal>

      <Modal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-180">
        <PrivacyContent data-id="element-181" />
      </Modal>
    </>;
}